import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { ShieldCheck, RotateCcw } from "lucide-react";
import { PAGES, ACTIONS, canAccess, canAct } from "@/lib/access";

function Row({ label, hint, checked, changed, onChange, testId }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5">
      <div className="min-w-0">
        <div className="text-sm flex items-center gap-1.5">{label}{changed && <span className="text-[9px] font-mono text-blue-300 bg-blue-500/15 px-1 rounded">özel</span>}</div>
        {hint && <div className="text-[10px] text-slate-500">{hint}</div>}
      </div>
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
    </div>
  );
}

export function AccessEditor({ role, perms, onChange, basePerms = {}, custom = false, title = "Sayfa ve Yetki Erişimi", resetLabel = "Rol varsayılanı" }) {
  if (!custom && (role === "koordinator" || role === "patron")) {
    return (
      <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3 text-xs text-emerald-200 flex items-center gap-2" data-testid="access-full">
        <ShieldCheck size={14} /> Patron ve Koordinatör tam yetkilidir; erişimleri kısıtlanamaz.
      </div>
    );
  }
  const fake = { role, custom_role_id: custom ? "x" : undefined, permissions: { ...basePerms, ...perms } };
  const set = (k, v) => onChange({ ...perms, [k]: v });
  const reset = () => onChange(Object.fromEntries(Object.entries(perms).filter(([k]) => !k.startsWith("page:") && !k.startsWith("act:") && k !== "view_revenue")));
  const pages = custom ? PAGES.filter((p) => !p.adminOnly) : PAGES;
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-950/40 p-3" data-testid="access-editor">
      <div className="flex items-center justify-between mb-1">
        <Label className="text-xs text-slate-300 font-mono uppercase tracking-widest flex items-center gap-1.5"><ShieldCheck size={13} /> {title}</Label>
        <button type="button" onClick={reset} className="text-[11px] text-slate-400 hover:text-slate-200 flex items-center gap-1" data-testid="access-reset">
          <RotateCcw size={11} /> {resetLabel}
        </button>
      </div>
      <div className="grid sm:grid-cols-2 gap-x-6 max-h-64 overflow-y-auto pr-1">
        {pages.map((p) => (
          <Row key={p.to} label={p.label} checked={canAccess(fake, p.to)} changed={typeof perms[`page:${p.to}`] === "boolean"}
               onChange={(v) => set(`page:${p.to}`, v)} testId={`access-page-${p.to === "/" ? "home" : p.to.slice(1).replace("/", "-")}`} />
        ))}
      </div>
      <div className="border-t border-slate-800 mt-2 pt-2">
        {ACTIONS.map((a) => (
          <Row key={a.key} label={a.label} hint={a.hint} checked={canAct(fake, a.key)} changed={typeof perms[a.key] === "boolean"}
               onChange={(v) => set(a.key, v)} testId={`access-action-${a.key.replace("act:", "")}`} />
        ))}
      </div>
    </div>
  );
}
